import { useMutation, type UseMutationOptions } from '@zg-rentals/react-query5';
import { BASE_URL } from '../../constants/urls';
import type { ApiResponseDto } from '@zg-rentals/ts-rental-manager-api-client';

export interface SendInvitationRequest {
  listingId: string;
  toEmail: string;
  renterFirstName?: string;
  renterLastName?: string;
  utmGuid?: string;
}

async function sendInvitationData(data: SendInvitationRequest): Promise<ApiResponseDto<unknown>> {
  const response = await fetch(`${BASE_URL}/rental-manager-api/api/v1/users/capps/handleApplicationInvitation`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error(`Failed to send application invitation: ${response.statusText}`);
  }

  return await response.json();
}

export function useSendTenantScreeningInvitation(
  options?: UseMutationOptions<ApiResponseDto<unknown>, Error, SendInvitationRequest, unknown>,
) {
  return useMutation({
    ...options,
    mutationFn: sendInvitationData,
  });
}
